export default __webpack_public_path__ + "static/bali-7ec8cbf110fcb9e1c6c1b24f6d5c7fbe.jpg";